import { Badge, Logo, NetworkBadge } from "@custos/ui";
import type { ReactNode } from "react";
import { useConfig } from "../lib/queries";

/** Signed-out admin screens: aurora backdrop, dark card. */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  const config = useConfig();
  return (
    <div className="relative flex min-h-dvh flex-col items-center overflow-hidden px-4 pt-5 pb-10">
      <div
        aria-hidden
        className="bg-aurora pointer-events-none absolute inset-x-0 top-0 h-[22rem] rounded-b-[44px] sm:h-[26rem]"
      />
      <div className="relative w-full max-w-md">
        <div className="mb-8 flex items-center justify-between gap-3 sm:mb-12">
          <span className="flex items-center gap-2 [&_span]:text-white">
            <Logo />
            <Badge tone="primary">Admin</Badge>
          </span>
          {config.data && <NetworkBadge label={config.data.badge} />}
        </div>
        <div className="mb-6 px-1 text-white">
          <h1 className="font-heading text-[32px] leading-tight font-medium tracking-[-0.03em]">{title}</h1>
          {subtitle && <p className="mt-2 text-base text-white/80">{subtitle}</p>}
        </div>
        <div className="animate-rise rounded-[32px] border border-line bg-surface p-5 shadow-2xl sm:p-7">
          {children}
        </div>
      </div>
    </div>
  );
}
